  export const add_only_if_not_exists = (map, url, name, checked=false) => {
    if (!map.getLayer(name) && checked) {
      map.addSource(name, {
        type: "raster",
        tiles: [url],
        tileSize: 256,
      });
      
      map.addLayer({
        id: name,
        type: "raster",
        source: name,
      });
    
      
    }
  }

   export const remove_image_layer = (map, name) => {
    if (map.getLayer(name)) {
      map.removeLayer(name);
      map.removeSource(name);
    }
  };